import gql from 'graphql-tag';

export const UnifiedEnterpriseOpenCourseMembershipsQuery = gql`
  query UnifiedEnterpriseOpenCourseMembershipsQuery($userId: String!, $slug: String!) {
    OpenCourseMembershipsV1Resource {
      findByUserAndSlug(userId: $userId, slug: $slug) {
        elements {
          id
          courseRole
        }
      }
    }
  }
`;

export const UnifiedEnterpriseOnDemandSpecialziationsMembershipsQuery = gql`
  query UnifiedEnterpriseOnDemandSpecialziationsMembershipsQuery($s12nId: String!) {
    OnDemandSpecializationMembershipsV1Resource {
      meByS12nId(s12nId: $s12nId) {
        elements {
          id
        }
      }
    }
  }
`;
